import { Control } from 'react-hook-form';

import { ICD9Procedure } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import { StyledFlex } from '@dreryk/react-components';

import { Icd9ProcedureField } from './Icd9ProcedureField';
import { useIcd9ProcedureSelector } from './Icd9ProcedureSelector.hooks';
import { Icd9ProcedureTable } from './Icd9ProcedureTable';

type Icd9ProcedureSelectorProps = {
   readonly control: Control;
   readonly dictionaryValidOn: Date;
   readonly defaultValues: ICD9Procedure[] | undefined;
};
export const ICD9_PROCEDURES = 'icd9Procedures';

export const Icd9ProcedureSelector = (props: Icd9ProcedureSelectorProps): JSX.Element => {
   const selector = useIcd9ProcedureSelector(props.control, props.defaultValues, ICD9_PROCEDURES);

   return (
      <StyledFlex direction={'column'} gap={'8px'}>
         <Icd9ProcedureField
            addIcd9Procedure={selector.addItem}
            invalid={selector.invalid}
            validate={selector.validate}
            dictionaryValidOn={props.dictionaryValidOn}
         />
         <Icd9ProcedureTable procedures={selector.selectedItems} removeItem={selector.removeItem} />
      </StyledFlex>
   );
};
